export default {
  addPagination,
  displayDocument,
  hideDocument,
  notebookDisplay,
  printButton,
};

function addPagination() {
  let nbSheets = $('.sheet').length;

  $('.sheet').each(function (index) {
    const hide = $(
      '.program-print-pagination-option span:first-child'
    ).hasClass('glyphicon-unchecked');
    const pagination = $('<div>')
      .addClass('program-print-pagination' + (hide ? ' hidden' : ''))
      .text(index + 1 + ' / ' + nbSheets);
    const logo = $('<div>')
      .addClass('program-print-pagination-logo')
      .append(
        $('#ShortLogoTemplate').clone().removeClass('hidden').removeAttr('id')
      );
    $(this).append(pagination).append(logo);
  });

  $('.program-print-pagination-option').click(function () {
    $(this)
      .find('span:first-child')
      .toggleClass('glyphicon-unchecked glyphicon-check');
    $('.program-print-pagination').toggleClass('hidden');
  });
}

function displayDocument() {
  $('.program-print-loading').animate(
    {
      opacity: 0,
    },
    500,
    function () {
      $('.sheet').animate(
        {
          opacity: 1,
        },
        500
      );
    }
  );
}

function hideDocument() {
  $('.sheet').animate(
    {
      opacity: 0,
    },
    500,
    function () {
      $('.program-print-loading').animate(
        {
          opacity: 1,
        },
        500
      );
    }
  );
}

function notebookDisplay() {
  const notebookDisplay = $('.program-print-notebook-option span:first-child');
  if (notebookDisplay.hasClass('glyphicon-check')) {
    $('.sheet').addClass('program-print-notebook');
  }

  $('.program-print-notebook-option').click(function () {
    $(this)
      .find('span:first-child')
      .toggleClass('glyphicon-unchecked glyphicon-check');
    $('.sheet').toggleClass('program-print-notebook');
  });
}

function printButton() {
  $('.program-print-print-icon').click(function () {
    window.print();
  });
}
